import Router from 'vue-router'
import routes from './routes'
import locale from '../lang/locale';

export default () => {
    let router =  new Router({
        routes,
        base: '/' + locale.base,
        mode: 'history',
        // mode: 'hash',
        linkExactActiveClass: 'exact-active',
        linkActiveClass: 'active',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    })
    router.beforeEach((to, from, next) => {
        // 如果需要登录验证 并且没有token 则跳转到登录页
        if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('token')) { 
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {
            next();
        }
        // if(to.matched.some(record => record.meta.title)){
        //     document.title = to.meta.title
        // }else{
        //     document.title = ''
        // }
    })
    return router
}